import {createAction} from '@reduxjs/toolkit';

export const setLogo = createAction('SETTINGS_SET_LOGO');
export const setLabels = createAction('SETTINGS_SET_LABELS');
export const setFrameRate = createAction('SETTINGS_SET_FRAME_RATE');
export const enableCompare = createAction('SETTINGS_ENABLE_COMPARE');
export const disableCompare = createAction('SETTINGS_DISABLE_COMPARE');
